export default function DiscountGuide() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-5xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-4 text-center">
          地域密着型クレジットカードの割引・還元の仕組み
        </h2>
        <p className="text-gray-600 text-center mb-12">
          提携施設でおトクに使える3つの特典
        </p>

        {/* 直売所割引 */}
        <div className="bg-gradient-to-r from-[#00A040]/5 to-[#00A040]/10 rounded-2xl p-8 mb-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-full md:w-1/3">
              <img
                src="https://www.ad.jacard.cr.mufg.jp/af/assets/img/text-best-deal-txt.png"
                alt="直売所5%割引"
                className="w-full h-auto"
              />
            </div>
            <div className="w-full md:w-2/3">
              <h3 className="text-xl font-bold text-[#003366] mb-4">
                <i className="ri-store-2-line text-[#00A040] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
                農産物直売所・ファーマーズマーケットで5%割引
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#00A040] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>全国1,100店舗以上が対象（2023年9月現在）</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#00A040] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>レジでの支払い時ではなく、ご請求時に5%割引</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#00A040] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>新鮮な地元野菜・果物・加工品がおトクに</span>
                </li>
              </ul>
              <a
                href="https://life.ja-group.jp/farm/market/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 mt-4 text-[#00A040] font-medium hover:underline cursor-pointer"
              >
                <span>お近くの店舗を探す</span>
                <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>

        {/* 給油所割引 */}
        <div className="bg-gradient-to-r from-[#FF9900]/5 to-[#FF9900]/10 rounded-2xl p-8 mb-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-full md:w-1/3">
              <img
                src="https://www.ad.jacard.cr.mufg.jp/af/assets/img/text-best-deal-txt2.png"
                alt="提携給油所 2円割引"
                className="w-full h-auto"
              />
            </div>
            <div className="w-full md:w-2/3">
              <h3 className="text-xl font-bold text-[#003366] mb-4">
                <i className="ri-gas-station-line text-[#FF9900] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
                提携給油所で1Lにつき2円割引
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FF9900] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>全国2,000店舗以上が対象（2023年9月現在）</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FF9900] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>ハイオク・レギュラーガソリン・軽油が対象</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#FF9900] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>1L毎の適用（1L未満は切り捨て）</span>
                </li>
              </ul>
              <div className="flex flex-wrap gap-4 mt-4">
                <a
                  href="https://jassrm.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#FF9900] font-medium hover:underline cursor-pointer"
                >
                  <span>提携給油所を検索</span>
                  <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <a
                  href="http://www.hokuren-ss.jp/station/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-[#FF9900] font-medium hover:underline cursor-pointer"
                >
                  <span>北海道エリア給油所を検索</span>
                  <i className="ri-external-link-line w-4 h-4 flex items-center justify-center"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* 提携店舗+2%還元 */}
        <div className="bg-gradient-to-r from-[#003366]/5 to-[#003366]/10 rounded-2xl p-8">
          <div className="flex flex-col md:flex-row items-center gap-8">
            <div className="w-full md:w-1/3">
              <img
                src="https://www.ad.jacard.cr.mufg.jp/af/assets/img/text-best-deal-txt3.png"
                alt="提携店舗+2%還元"
                className="w-full h-auto"
              />
            </div>
            <div className="w-full md:w-2/3">
              <h3 className="text-xl font-bold text-[#003366] mb-4">
                <i className="ri-add-circle-line text-[#003366] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
                提携店舗で+2%ポイント還元
              </h3>
              <ul className="space-y-2 text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#003366] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>提携スーパー・購買店舗・通販サイト・旅行サービスなどが対象</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#003366] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>通常ポイントに加えて+2%還元（1ポイント4円換算）</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-[#003366] flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                  <span>原則ご利用月の翌々月にポイント還元</span>
                </li>
              </ul>
              <p className="text-xs text-gray-500 mt-4">
                ※農産物直売所・ファーマーズマーケット、提携給油所は本特典の対象外です。
              </p>
            </div>
          </div>
        </div>

        {/* 入会特典 */}
        <div className="mt-12 bg-gradient-to-r from-[#FFD700]/20 to-[#FFA500]/20 rounded-2xl p-8 border-2 border-[#FFD700]">
          <h3 className="text-xl font-bold text-[#003366] mb-6 text-center">
            <i className="ri-gift-line text-[#FFD700] mr-2 w-6 h-6 inline-flex items-center justify-center"></i>
            入会特典：最大12,000円相当ポイントプレゼント
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-white rounded-lg p-6">
              <h4 className="font-bold text-[#003366] mb-3">ご入会サンクスプレゼント</h4>
              <p className="text-gray-700 text-sm mb-2">
                ご入会日から3ヵ月後末日までのショッピングご利用合計額に応じてポイント進呈
              </p>
              <p className="text-[#FF9900] font-bold">80,000円以上のご利用で最大12,000円相当</p>
              <p className="text-xs text-gray-500 mt-2">※WEBエントリーが必要です</p>
            </div>
            <div className="bg-white rounded-lg p-6">
              <h4 className="font-bold text-[#003366] mb-3">携帯電話料金支払い特典</h4>
              <p className="text-gray-700 text-sm mb-2">
                携帯電話利用料金のお支払いにこのカードを登録すると
              </p>
              <p className="text-[#FF9900] font-bold">1,000円相当ポイント（250ポイント）</p>
              <p className="text-xs text-gray-500 mt-2">※au、NTTドコモ、ソフトバンク、ワイモバイルが対象</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
